import { DateRange } from 'react-day-picker'
import { startOfDay, endOfDay, subDays, startOfWeek, endOfWeek } from 'date-fns'
import { PresetKey, PresetRangesMap } from '../types'

export function getPresetRanges(): PresetRangesMap {
  const today = new Date()
  const lastWeekStart = startOfWeek(subDays(today, 7), { weekStartsOn: 1 })
  const lastWeekEnd = endOfWeek(subDays(today, 7), { weekStartsOn: 1 })
  const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1)
  const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0)

  return {
    today: {
      from: startOfDay(today),
      to: endOfDay(today),
    },
    lastWeek: {
      from: startOfDay(lastWeekStart),
      to: endOfDay(lastWeekEnd),
    },
    lastMonth: {
      from: startOfDay(lastMonthStart),
      to: endOfDay(lastMonthEnd),
    },
  }
}

export function checkPresetMatch(
  range: DateRange | undefined,
  presets: PresetRangesMap
): PresetKey | '' {
  if (!range?.from || !range?.to) return ''
  const rangeFromTime = range.from.getTime()
  const rangeToTime = range.to.getTime()
  for (const [key, preset] of Object.entries(presets)) {
    if (preset.from.getTime() === rangeFromTime && preset.to.getTime() === rangeToTime) {
      return key as PresetKey
    }
  }
  return ''
}
